<angular-editor
  [placeholder]="'dashboard.operational.dialogs.enterTextHere' | t"
  [(ngModel)]="data.content"
  [(config)]="config"
></angular-editor>
<button mat-button color="success" (click)="submitForm()">{{ 'common.save' | t }}</button>
